angular.module('gc.utils', [])
  .service('Utils', [
    '$window', '$document', '$q', '$translate', '$injector',
    function($window, $document, $q, $translate, $injector) {
      

    function getQueryParamValue(search, param) {
      var query = search.substring(1); 
      var params = query.split('&');
    
      for (var i = 0; i < params.length; i++) {
        var item = params[i].split('='); 
        if (decodeURIComponent(item[0]) === param) { 
          return decodeURIComponent(item[1] || undefined);
        }
      }
      return undefined;
    }

    // for visibility API
    var visStateKey, visEventKey, keys = {
      hidden: "visibilitychange",
      webkitHidden: "webkitvisibilitychange",
      mozHidden: "mozvisibilitychange",
      msHidden: "msvisibilitychange"
    };
    for (visStateKey in keys) {
      if (visStateKey in document) {
        visEventKey = keys[visStateKey];
        break;
      }
    }

    return {

      iOS: function() {
        if (typeof this._isIOS === 'undefined') {
          this._isIOS = /iPad|iPhone|iPod/.test($window.navigator.userAgent) && !$window.MSStream;
        }
        return this._isIOS;
      },

      // Don't show the emoticon and the smartEdit buttons on touch devices
      isMobile: function() {
        if (typeof this._isMobile === 'undefined') {
          this._isMobile = /iPhone|iPad|iPod|Android|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test($window.navigator.userAgent);
        }
        return this._isMobile;
      },

      inApp: function() {
        return this.getParameterByName('inapp') && this.getParameterByName('inapp') !== 'false';
      },

      isFacebookApp: function() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
      },

      isProd: function() {
        return !/^dev./.test(window.location.hostname);
      },

      /**
       * Check if page is included in an iframe
       */
      inIframe: function() {
        try {
          return window.self !== window.top;
        } catch (e) {
          return true;
        }
      },

      inOverlay: function() {
        return this.getParameterByName('overlay') === 'true';
      },

      /**
       * Example:
       *   appendGetParam('http://google.fr/', 'foo=bar')
       *   => http://google.fr?foo=bar
       *
       *   appendGetParam('http://google.fr/?1', 'foo=bar')
       *   => http://google.fr/?1&foo=bar
       */
      appendGetParam: function(url, param) {
        if (url.indexOf('?') === -1) {
          return url + '?' + param;
        } else {
          return url + '&' + param;
        }
      },

      /**
       * removeHash('http://google.com/foo#bar')
       * => http://google.com/foo
       */
      removeHash: function(url) {
        return url.replace(/#.*$/, '');
      },

      // https://stackoverflow.com/a/25490531/505836
      getCookieValue: function(a) {
        var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
      },

      // remove attributes from html (except <a> and <img> tags)
      stripAttributes: function(html) {
        return html.replace(/<(?!img|a)\s*(\w+).*?>/g, '<$1>')
      },

      /**
       * Look if there is the ?comment_id param
       * If present do the logic to display it
       */
      getParameterByName: function(name) {
        if (!this._paramCache) this._paramCache = {};
        
        if (typeof this._paramCache[name] !== 'undefined') {
          return this._paramCache[name];
        }

        var param = getQueryParamValue(location.search, name)

        this._paramCache[name] = param;

        return param;
      },

      /**
       * Remove a GET parameter from a url
       * https://stackoverflow.com/a/1634841/505836
       */
      removeUrlParameter: function(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts= url.split('?');
        if (urlparts.length>=2) {

          var prefix= encodeURIComponent(parameter)+'=';
          var pars= urlparts[1].split(/[&;]/g);

          //reverse iteration as may be destructive
          for (var i= pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
              pars.splice(i, 1);
            }
          }

          return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
      },

      /**
       * Generate uniqu hash from string
       *
       * https://stackoverflow.com/a/7616484/505836
       */
      hash: function(str) {
        var hash = 0, hash2 = 0, i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
          chr   = str.charCodeAt(i);
          hash  = ((hash << 5) - hash)
          hash = hash + chr
          hash |= 0; // Convert to 32bit integer          
        }
        
        return hash;
      },

      getUniqueUrlIdentifier: function() {
        return this.hash(this.getParameterByName('url') + this.getParameterByName('identifier')).toString();
      },

      getScrollPosition: function() {
        if (this.inOverlay()) {
          var offset = $('.gc-body').offset();
          return {
            top: -offset.top,
            left: -offset.left,
          };
        }

        var doc = $document[0];
        var docEl = $document[0].documentElement;
        return {
          top: window.pageYOffset || docEl.scrollTop || doc.body.scrollTop || 0,
          left: window.pageXOffset || docEl.scrollLeft || doc.body.scrollLeft || 0
        };
      },

      preloadImage: function (url) {
        var deferred = $q.defer();
        var img = new Image();
        img.onload = function() {
          deferred.resolve(this);
        };
        img.onerror = function() {
          deferred.reject();
        };
        img.src = url;
        return deferred.promise;
      },

      appendScript: function(src) {
        var $script = document.createElement('script');
        $script.type = 'text/javascript';
        $script.src = src;
        document.head.appendChild($script);
      },

      appendStyle: function(href) {
        var $style = document.createElement('link');
        $style.rel = 'stylesheet';
        $style.href = href;
        document.head.appendChild($style);
      },

      voteIcon: function (vote) {
        var icon = {};

        icon['-3'] = '<span class="gcicon-rulesviolation"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>';
        icon['-2'] = '<span class="gcicon-troll"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>';
        icon['-1'] = '<span class="gcicon-offtopic"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>';
        icon['0'] = '';
        icon['1'] = '<span class="gcicon-like"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>';
        icon['2'] = '<span class="gcicon-target"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>';
        icon['3'] = '<span class="gcicon-diamond"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span></span>';

        if (icon[vote]) return icon[vote];
      },

      filterOutTrolls: function(voters) {
        var user = $injector.get('GcUser').getUser();

        return voters.filter(function(vote) {
          // if the user has a bad reputation
          if (vote.score_received <= -.6 && vote.score <= -2) {
            // if the vote doesn't belong to actual user
            if (!user || user._id !== vote.user) return false;
          }
          return true;
        });
      },

      filterOutShadowVotes: function(voters) {
        var user = $injector.get('GcUser').getUser();

        return voters.filter(function(vote) {
          if (vote.visible === false) {
            if (!user) return false;
            if (user._id !== vote.user) return false;
          }
          return true;
        });
      },

      getVoters: function(comment, ignoreTrolls) {
        if (comment.voters && comment.voters.length > 0) {
          // exclude 'without opinion' votes
          var voters = comment.voters.filter(function(vote) {
            return vote.score !== 0;
          });

          voters = this.filterOutShadowVotes(voters);
          if (ignoreTrolls) voters = this.filterOutTrolls(voters);

          return voters;
        }

        return [];
      },

      topVoters: function (comment, ignoreTrolls) {
        var scores = [];
        var voters = this.getVoters(comment, ignoreTrolls)

        if (voters.length === 0) return '';

        if (CommentService.website.votes_discreet) {
          var total = 0;
          voters.forEach(function(vote) {
            total += (vote.score > 0 ? 1 : 0);
          });

          if (total <= 0) return '';

          return this.voteIcon(1) + ' ' + total;
        }

        var scoresGrouped = voters.map(function(vote) {
          return vote.score;
        }).reduce(function (prev, cur) {
          prev[cur] = (prev[cur] || 0) + 1;
          return prev;
        }, {});

        var scores = [];
        for (var scoreName in scoresGrouped) {
          scores.push({ name: Number(scoreName), count: scoresGrouped[scoreName] });
        }

        var user = $injector.get('GcUser').getUser();
        if (!user) {
          // remove 'troll' votes only if their total is less than X percent
          var trolls = scores.find(score => score.name === -2);
          var totalTrolls = trolls ? trolls.count : 0;
          var totalVotes = voters.length;
          var trollPercentage = totalTrolls * 100 / totalVotes;
          if (totalTrolls > 0 && trollPercentage <= 30) {
            var index = scores.findIndex(score => score.name === -2);
            scores.splice(index, 1);
          }
        }

        // with more votes first
        scores.sort(function (a, b) {
          return b.count - a.count;
        });

        // only two three scores
        scores = scores.slice(0, 3);

        var string = scores.map(function (score) {
          return this.voteIcon(score.name) + ' ';
        }.bind(this)).join('');

        string += '<span class="count">' + voters.length + '</span>' || '';
        return string;
      },

      votesCount: function (comment, ignoreTrolls) {
        var scores = [];
        var voters = this.getVoters(comment, ignoreTrolls)

        var scoresGrouped = voters.map(function(vote) {
          return vote.score;
        }).reduce(function (prev, cur) {
          prev[cur] = (prev[cur] || 0) + 1;
          return prev;
        }, {});

        function kFormatter(num) {
          return num > 999 ? (num/1000).toFixed(1) + 'k' : num
        }

        var scores = [];
        var totalScores = 0;
        for (var scoreName in scoresGrouped) {
          scores.push({ name: scoreName, count: kFormatter(scoresGrouped[scoreName]) });
          totalScores += scoresGrouped[scoreName];
        }

        if (!scores.length) return '';

        // with more votes first
        scores.sort(function (a, b) {
          return b.count - a.count;
        });

        var string = '<span class="all">' + $translate.instant('all') + ' (' + totalScores + ')</span> ';

        string += scores.map(function (score) {
          return this.voteIcon(score.name) + ' <span class="count">' + score.count + '</span> ';
        }.bind(this)).join('');

        return string;
      },

      /*
       * wrapper arround Visibility API
       * https://stackoverflow.com/a/19519701/505836
       */
      pageVisible: function(c) {
        if (c) document.addEventListener(visEventKey, c);
        return !document[visStateKey];
      },

      isScrolledIntoView: function(parent, el, partially) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        if (partially) {
          // Partially visible elements return true:
          return elemTop < window.innerHeight && elemBottom >= 0;
        } else {
          // Only completely visible elements return true:
          return (elemTop >= 0) && (elemBottom - rect.height <= parent.offsetHeight);
        }
      },

      isSso () {
        return CommentService.website.sso.active;
      }

    }

}]);
